import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFinanceStream, type FinanceChange } from 'sama-shared';
import { partnerCollectPayoutApi } from '../api/partner-collect/partner-collect-payout.api';

type Tag = Parameters<typeof partnerCollectPayoutApi.util.invalidateTags>[0][number];

const tagsFor = ({ entity, id }: FinanceChange): Tag[] => {
  switch (entity) {
    case 'partner-invoice':
      return [
        { type: 'PartnerInvoice', id: 'LIST' },
        ...(id ? [{ type: 'PartnerInvoice' as const, id }] : []),
      ];
    case 'partner-payout':
      return [
        { type: 'PartnerCollectPayout', id: 'LIST' },
        { type: 'PartnerCollectSettlement', id: 'LIST' },
        ...(id ? [{ type: 'PartnerCollectPayout' as const, id }] : []),
      ];
    case 'payout':
      // getAdminPayouts/getAdminPayoutById etiquetan por partnerId, no por id del pago.
      return ['Payout'];
  }
};

/**
 * Stream global de finanzas para el superadmin (todos los partners, sin `partnerId`).
 * Si una vista necesita un solo partner, que filtre en cliente.
 */
export const useFinanceLiveSync = (enabled: boolean) => {
  const dispatch = useDispatch();
  const onInvalidate = useCallback(
    (changes: FinanceChange[]) =>
      dispatch(partnerCollectPayoutApi.util.invalidateTags(changes.flatMap(tagsFor))),
    [dispatch]
  );
  useFinanceStream({ enabled, onInvalidate });
};
